
  import '/Users/jilin/projects/antd/rc-dialog/docs/demo/draggable.md?watch=parent';
  export const texts = [];
  